export default __webpack_public_path__ + "static/media/contract.b2b825b3.png";